<div class="p-4 overflow-auto max-h-[85vh]">

    <div class="flex justify-between -mt-4">
      <h2 class="text-xl font-semibold">Courses </h2>
      <p-button icon="pi pi-plus" label="Add Course" (click)="openAddModal()" class="mb-3"></p-button>
    </div>
  
    <p-table [value]="courses" [rows]="rows" [totalRecords]="totalRecords" [lazy]="true"
      (onLazyLoad)="loadCourses($event)" [loading]="loading">
  
      <ng-template pTemplate="header">
        <tr>
          <th>Course Name</th>
          <!-- <th>Action</th> -->
        </tr>
      </ng-template>
  
      <ng-template pTemplate="body" let-course>
        <tr>
          <td>{{ course.name }}</td>
         
          <!-- <td>
            <p-button icon="pi pi-trash" (click)="openDeleteCourse(course)"></p-button>
          </td> -->
        </tr>
      </ng-template>
  
      <ng-template pTemplate="loading">
        <tr>
          <td colspan="1" class="text-center">
            <p-progressSpinner></p-progressSpinner>
          </td>
        </tr>
      </ng-template>
  
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="1" class="no-data-record-found">
            <p>No records found</p>
          </td>
        </tr>
      </ng-template>
    </p-table>
  
  </div>
  
  <!-- Delete Department Modal -->
  <ng-container *ngIf="displayAddModal">
    <p-dialog [(visible)]="displayAddModal" [modal]="true" [style]="{width: '50rem'}" [closable]="false">
      <app-create-course
        [orgId]="orgId" 
        [campuses]="campuses"
        [departments]="departments"
        (reload)="reload()"
        (close)="displayAddModal = false"></app-create-course>
    </p-dialog>
  </ng-container>
  